import { render } from "./SectionGroupsDirectSale.vue?vue&type=template&id=e2eeda50&scoped=true"
import script from "./SectionGroupsDirectSale.vue?vue&type=script&lang=js"
export * from "./SectionGroupsDirectSale.vue?vue&type=script&lang=js"

import "./SectionGroupsDirectSale.vue?vue&type=style&index=0&id=e2eeda50&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2eeda50"]])

export default __exports__